import React from 'react'
import './checkout.less'
import { withRouter } from "react-router";
import { setHeader } from '@/util/set-header';
import { syCheckoutApi,cancelCheckooutApi,applyCheckooutApi } from "@/api/sany";
import { NoticeBar, Steps, DatePicker, ActionSheet, TextareaItem, Button, Modal, Toast } from "antd-mobile";
import { getSanyPhone } from '@/util/storage';
import { getUrlQueryDic } from '@/util/util';
const Step = Steps.Step
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
@(withRouter as any)
export default class Checkout extends React.Component<any,any> {
  state = {
    checkoutInfo:{
      store_name:'',
      bed_info:'',
      live_property:'',
      room_type:'',
      start_day:'',
      end_day: '',
      pay_type:'',
      deposit:'',
      reject_reason:'', //驳回原因
      organization: '',
      checkout_id: '',
      checkout_day:'', // 退房时间
      first_day: '',
      two_day: '',
      status_text: '',
      reasonArr: []
    },
    notice: '退房申请提交后不可修改，请及认真填写退房信息哦~',
    date: now,
    reason: '请选择退房原因',
    reasonId: '',
    remark: '',
    status: '' 
  }
  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.stepComponent = this.stepComponent.bind(this)
    this.checkoutComponent = this.checkoutComponent.bind(this)
    this.submitButton = this.submitButton.bind(this)
    this.submitClick = this.submitClick.bind(this)
    this.remarkChange = this.remarkChange.bind(this)
    this.checkoutRoomDetail = this.checkoutRoomDetail.bind(this)
  }

  componentDidMount() {
    setHeader({title: '退房', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightComponent()})
    this.checkoutRoomDetail()
  }

  // 获取详情
  async checkoutRoomDetail() {
    const phone = getSanyPhone()
    let reserveId = ''
    const dic = getUrlQueryDic(this.props.location.search)
    if (dic.id) {
      reserveId = dic.id
    } else if (this.props.location.state.reserveId) {
      reserveId = this.props.location.state.reserveId
    }
    const obj = {
      reserve_id: reserveId,
      phone: phone
    }
    const { data } = await syCheckoutApi(obj)
    if (data.code === 'SUCCESS') {
      this.setState({
        checkoutInfo:data.data,
        remark:data.data.remark,
        reason:data.data.reason ? data.data.reason : '请选择退房原因',
        status: data.data.status
      })
      this.configNotice()
    } else {
      Toast.info(data.msg)
    }
  }

  // 提交退房
  async submitCheckout() {
    if (this.state.reasonId === '') {
      Toast.info('请选择退房原因~')
      return
    }
    const params = {
      reserve_id: this.props.location.state.reserveId,
      checkout_id: this.state.checkoutInfo.checkout_id,
      checkout_day: this.formatDate(this.state.date),
      reason: this.state.reasonId,
      remark: this.state.remark,
      phone: getSanyPhone()
    }
    Toast.loading('加载中...')
    const {data} = await applyCheckooutApi(params)
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.checkoutRoomDetail()
    } else {
      Toast.info(data.msg)
    }
  }

  // 取消退房
  async cancelCheckout() {
    const params = {
      checkout_id: this.state.checkoutInfo.checkout_id,
      phone: getSanyPhone()
    }
    const {data} = await cancelCheckooutApi(params)
    if (data.code === 'SUCCESS') {
      Toast.info('已取消~')
      this.checkoutRoomDetail()
    } else {
      Toast.info(data.msg)
    }
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightComponent() {
    if (this.state.status === 'audit') {
      return (
        <img onClick={()=>this.callPhone()} src="/public/assets/img/call_icon.png" alt=""/>
      )
    }
  }

  callPhone() {
    window.location.href = ("tel:15001779075")
  }

  configNotice() {
    // 0 待审核 1：退宿中 2：已取消 3：已失效 4：已退房 5：已驳回
    let notice = '退房申请提交后不可修改，请及认真填写退房信息哦~'
    if (this.state.status === '0' || this.state.status === '1') {
      notice = '已成功提交退房申请~'
    } else if (this.state.status === '4') {
      notice = '退房申请已通过，办理退房成功~'
    } else if (this.state.status === '5') {
      notice = '退房申请被驳回，需要退房请重新申请~'
    } else if (this.state.status === '2') {
      notice = '退房申请已取消，需要退房请重新申请~'
    } else if (this.state.status === '3') {
      notice = '退房申请已过期，需要退房请重新申请~'
    }
    this.setState({
      notice
    })
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

  // 驳回原因
  rejectReasonComponent() {
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151', width: '100px'}}>驳回原因：</span>
          <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.state.checkoutInfo.reject_reason}</span>
        </div>
      </div>
    )
  }

  // 步骤条
  stepComponent() {
    // 0 待审核 1：退宿中 2：已取消 3：已失效 4：已退房 5：已驳回
    const status2 = this.state.status !== '' ? 'finish' : 'wait'
    const status = this.state.status !== '' ? (this.state.status !== '0'&& this.state.status !== '1' ? 'finish' : 'wait') : 'wait'
    const title = this.state.status !== '' ? (this.state.status !== '0'&& this.state.status !== '1' ? this.state.checkoutInfo.status_text : '完成') : '完成'
    const step2Icon = this.state.status !== '' ? '/public/assets/img/step_loading_select.png' : '/public/assets/img/step_loading.png'
    let step3Icon = '/public/assets/img/step_room.png'
    if (this.state.status === '4') {
      step3Icon = '/public/assets/img/step_room_select.png'
    } else if (this.state.status === '0') {
      step3Icon = '/public/assets/img/step_room.png'
    } else if (this.state.status === '3' || this.state.status === '2' || this.state.status === '5') {
      step3Icon = '/public/assets/img/step_end.png'
    } else {
      step3Icon = '/public/assets/img/step_room.png'
    }
    const firstDay = this.state.status === '' ? '' : this.state.checkoutInfo.first_day
    const twoDay = this.state.status === '' ? '' : this.state.checkoutInfo.two_day
    return (
      <div className="step-body">
        <Steps direction="horizontal" size="small">
          <Step status="finish" title={this.customTitle('退房申请', 'finish')} description={this.customDesc(firstDay, 'finish')} icon={this.customIcon('/public/assets/img/step_start_select.png')} />
          <Step status="wait" title={this.customTitle('宿管处理中', status2)} description={this.customDesc('', status2)} icon={this.customIcon(step2Icon)} />
          <Step status="wait" title={this.customTitle(title, status)} description={this.customDesc(twoDay, status)} icon={this.customIcon(step3Icon)} />
        </Steps>
      </div>
    )
  }

  customTitle(title: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <div style={{fontSize:'12px', color: color}}>{title}</div>
    )
  }

  customDesc(desc: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <span style={{color: color, fontSize: '12px'}}>{desc}</span>
    )
  }

  customIcon(img: string) {
    return (
      <img src={img} alt="" style={{width: '25px', height: '25px'}}/>
    )
  }

  roomInfoComponent() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{color: '#333333', fontSize: '14px'}}>房间信息</span>
          </div>
          <div className="dorm-info-top">
            <span style={{color: '#868686', fontSize: '16px'}}>{this.state.checkoutInfo.store_name}</span>
            <span style={{color: '#1b1b1b', fontSize: '14px'}}>{this.state.checkoutInfo.bed_info}</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.live_property}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.room_type}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>租期：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.start_day}~{this.state.checkoutInfo.end_day}</span>
            </div>
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.pay_type}</span>
            </div>
            {this.state.checkoutInfo.pay_type === '部门划转' ?
                <div className="between-row" style={{height: '30px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>扣费部门：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.organization}</span>
                </div> : null}
            <div className="between-row" style={{height: '30px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>押金：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.deposit}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 退房信息
  checkoutComponent() {
    const minDate = new Date()
    // const maxDate = this.state.checkoutInfo.end_day.length > 0 ? new Date(this.state.checkoutInfo.end_day) : undefined
    // maxDate={maxDate}
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{color: '#333333', fontSize: '14px'}}>退房信息</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>{this.state.status === '' ? <span style={{color: 'red'}}>*</span> : null}退房时间：</span>
              {this.state.status === '' ? 
                <DatePicker mode="date" title="选择时间" extra="Optional" value={this.state.date} minDate={minDate}  onChange={date => this.setState({ date })}>
                  <span style={{color: '#dd6572', fontSize: '14px'}}>{this.formatDate(this.state.date) + ' >'}</span>
                </DatePicker>  :
                <span style={{color: '#868686', fontSize: '13px'}}>{this.state.checkoutInfo.checkout_day}</span>
              }
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>{this.state.status === '' ? <span style={{color: 'red'}}>*</span> : null}退房原因：</span>
              {this.state.status === '' ?
                <span onClick={()=>this.showActionSheet()} style={{color: '#868686', fontSize: '12px'}}>{this.state.reason + " >"}</span> :
                <span style={{color: '#868686', fontSize: '12px'}}>{this.state.reason}</span>
              }
            </div>
            <div className="dorm-info-bottom">
              <div style={{color: '#434343', fontSize: '13px',width: '60px'}}>备注：</div>
              {this.state.status === '' ?
                <TextareaItem className="remark-input" maxLength={50} onChange={e => this.remarkChange(e)} placeholder="请输入备注(50字以内)" rows={3} /> :
                <span style={{color: '#868686', fontSize: '12px',overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.state.remark}</span>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 格式化时间
  formatDate(date: any) {
    /* eslint no-confusing-arrow: 0 */
    const pad = (n: number) => n < 10 ? `0${n}` : n;
    const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    // const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${dateStr}`;
  }

  // 选择退房类型
  showActionSheet = () => {
    let BUTTONS: any[] = [];
    this.state.checkoutInfo.reasonArr.forEach((ele: any) => {
      BUTTONS.push(ele.name)
    })
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      message: '请选择退房原因',
      maskClosable: true
    },
    (buttonIndex: number) => {
      if (buttonIndex >= 0 && buttonIndex < BUTTONS.length) {
        const id = (this.state.checkoutInfo.reasonArr[buttonIndex] as any).id
        const text = (this.state.checkoutInfo.reasonArr[buttonIndex] as any).name
        this.setState({
          reasonId: id,
          reason: text
        })
      }
    });
  }

  remarkChange(v: any) {
    this.setState({
      remark: v
    })
  }

  submitButton() {
    if (this.state.status === '4') {
      return
    } else {
      let title =  ''
      switch (this.state.status) {
        case '':
          title = '提交退房申请'
          break;
        case '0':
          title = '取消退房申请'
          break;
        case '1':
          title = ''
          break
        default:
          title = '重新添加退房申请'
          break;
      }
      return (
        <Button className="submit-btn"  onClick={() => this.submitClick()}>{title}</Button>
      )
    }
  }

  submitClick() {
    if (this.state.status === '') {
      Modal.alert('退房', '退房后到期将无法入住，确认退房吗？', [
        { text: '取消', onPress: () => console.log('cancel') },
        { text: '确定', onPress: () => this.submitCheckout() },
      ])
    } else if (this.state.status === '0'){
      this.cancelCheckout()
    } else {
      this.setState({
        status: '',
        date: now,
        reason: '请选择退房原因',
        reasonId: '',
      })
    }
  }

  render() {
    return (
      <div className="checkout">
        {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
        {this.stepComponent()}
        {this.state.status === '5' && this.state.reason.length > 0 ? this.rejectReasonComponent() : null}
        {this.roomInfoComponent()}
        {this.checkoutComponent()}
        {this.state.status === '1'?'':this.submitButton()}
      </div>
    )
  }
}